var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('print-dropdown-button',{attrs:{"buttonLabel":_vm.buttonLabel},on:{"printClicked":_vm.createTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }